import { useEffect, useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function InsightsCard() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/insights")
      .then((r) => setData(r.data))
      .catch(() => setData({ insights: [], message: "Couldn't load insights right now" }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="kawaii-card p-6 mb-6" data-testid="insights-card">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-kawaii-lavender to-kawaii-pink flex items-center justify-center">
          <Sparkles className="w-5 h-5 text-white" strokeWidth={2.5} />
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-kawaii-textSoft font-bold">Gentle observations</p>
          <h3 className="font-heading text-lg font-semibold text-kawaii-text">Pattern insights</h3>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-kawaii-textSoft text-sm">
          <Loader2 className="w-4 h-4 animate-spin" /> Looking for gentle patterns...
        </div>
      ) : data?.insights?.length ? (
        <ul className="space-y-3">
          {data.insights.map((ins, i) => (
            <li key={`${i}-${ins.slice(0, 24)}`} className="flex gap-3 items-start p-3 rounded-2xl bg-kawaii-lavender/10 border border-kawaii-lavender/30">
              <span className="text-lg leading-none">🌷</span>
              <p className="text-sm text-kawaii-text font-body leading-relaxed" data-testid={`insight-${i}`}>{ins}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-kawaii-textSoft font-body italic">
          {data?.message || "Not enough data yet — keep journaling and patterns will emerge ♡"}
        </p>
      )}
    </div>
  );
}
